import { render, staticRenderFns } from "./informationButton.vue?vue&type=template&id=8f720a36"
import script from "./informationButton.vue?vue&type=script&lang=js"
export * from "./informationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports